export interface IMultiSelectableConditionallyAsynchronously<T, TCondition> {
  // 戻り値がnullの場合はクリア.undefinedの場合はキャンセル.
  selectOptionsConditionally(condition: TCondition, defaultOptions?: T[]): Promise<T[]>;
}

export function instanceOfIMultiSelectableConditionallyAsynchronously<T, TCondition>(instance: any): instance is IMultiSelectableConditionallyAsynchronously<T, TCondition> {
  return instance && (instance.selectOptionsConditionally !== undefined);
}
